import En1 from "../../../../content/blog/ann_choi/en.md";
import Tc1 from "../../../../content/blog/ann_choi/tc.md";
import Jp1 from "../../../../content/blog/ann_choi/jp.md";
import * as React from 'react';
export default {
  En1,
  Tc1,
  Jp1,
  React
};